var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"50px 0","text-align":"center"}},[_vm._v("敬请期待")])
}
var staticRenderFns = []

export { render, staticRenderFns }